import { createSlice } from '@reduxjs/toolkit';
import { analyseText, getPackage, updateWordsProfile } from 'api/trigger-words';
import { dispatch } from '../index';

const overAllTotalDefault = {
    learning: '-',
    reading: '-',
    writing: '-',
    oralCommunication: '-',
    numeracy: '-'
};

export const initialState = {
    // for analyse text
    foundWordList: [],
    overallTotal: overAllTotalDefault,
    isLoading: false,

    // for trigger words
    isLoadingPackages: false,
    packages: [],
    selectedPackage: null
};

const slice = createSlice({
    name: 'analyseText',
    initialState,
    reducers: {
        setFoundWordList(state, action) {
            const { foundWordList = [] } = action.payload;
            state.foundWordList = foundWordList;
        },
        setOverAllTotal(state, action) {
            const { overallTotal = overAllTotalDefault } = action.payload;
            state.overallTotal = overallTotal;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setPackages(state, action) {
            state.packages = action.payload;
        },
        setSelectedPackage(state, action) {
            state.selectedPackage = action.payload;
        },
        setIsLoadingPackages(state, action) {
            state.isLoadingPackages = action.payload;
        }
    }
});

export const { setSelectedPackage } = slice.actions;

export default slice.reducer;

export function processAnalyseText(params) {
    return async () => {
        try {
            dispatch(slice.actions.setIsLoading(true));
            const response = await analyseText(params);
            const { data } = response;
            await setAnalyseTextResults(data);
        } catch (e) {
            throw new Error(e.message);
        } finally {
            dispatch(slice.actions.setIsLoading(false));
        }
    };
}

export function processGetPackage(packageName) {
    return async () => {
        try {
            dispatch(slice.actions.setIsLoadingPackages(true));
            const response = await getPackage(packageName);
            const { data } = response;
            await setPackageInfoResult(data);
        } catch (e) {
            throw new Error(e.message);
        } finally {
            dispatch(slice.actions.setIsLoadingPackages(false));
        }
    };
}

export function editWordsProfile(params) {
    return async () => {
        try {
            await updateWordsProfile(params);
        } catch (e) {
            throw new Error(e.message);
        }
    };
}

async function setAnalyseTextResults(data) {
    const { foundWordList = [], resultsProfile = {} } = data;
    dispatch(slice.actions.setFoundWordList({ foundWordList }));
    let overallTotal = resultsProfile?.profile ? resultsProfile.profile : overAllTotalDefault;
    dispatch(slice.actions.setOverAllTotal({ overallTotal }));
}

async function setPackageInfoResult(data) {
    if (data.length > 0) {
        data = data.sort((a, b) => a.certificate - b.certificate);
    }
    dispatch(slice.actions.setSelectedPackage(data[0]));
    dispatch(slice.actions.setPackages(data));
}
